import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import { useSettingsStore } from '@/store/modules/settings';
import { useTabsStore } from '@/store/modules/tabs';
import { handleActivePath } from '@/utils/routes';
import { keepAliveMaxNum } from '@/config';
import VabProgress from 'nprogress';
import { useRouterHelperStore } from '~/src/store/modules/routerHelper';

import { useRoute, useRouter } from 'vue-router';
import { inject, ref, watchEffect, nextTick, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter(); // 新增：router实例
    const $sub = inject('$sub');
    const $unsub = inject('$unsub');
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const tabsStore = useTabsStore();
    const {
      getVisitedRoutes: visitedRoutes
    } = storeToRefs(tabsStore);
    const routerHelper = useRouterHelperStore();
    const componentRef = ref();
    const routerKey = ref();
    const keepAliveNameList = ref();
    const updateKeepAliveNameList = (refreshRouteName = null) => {
      // 1. 基础tabs路由缓存列表（兼容空数组）
      const baseList = [];
      visitedRoutes.value.forEach(item => {
        if (!item.meta.noKeepAlive && item.name !== refreshRouteName) {
          baseList.push(item.name);
        }
      });
      // 2. 追加当前处于编辑状态的Edit组件（核心：让编辑页被缓存）
      if (visitedRoutes.value.length > 0) {
        visitedRoutes.value.forEach(tabRoute => {
          const editStatus = routerHelper.getEditStatus(tabRoute.name);
          if (editStatus.isEditing && !editStatus.route.meta?.noKeepAlive) {
            baseList.push(editStatus.route.name);
          }
        });
      }
      // 3. 去重 + 赋值（避免重复缓存）
      keepAliveNameList.value = Array.from(new Set(baseList));
    };
    // 更新KeepAlive缓存页面
    watchEffect(() => {
      routerKey.value = handleActivePath(route, true);
      updateKeepAliveNameList();
    });
    // 获取源码地址
    $sub('get-code', () => {
      // window.open(
      //   `https://github.com/vue-admin-beautiful/admin-plus/blob/main/${componentRef.value.$options.__source}`
      // )
    });
    $sub('reload-router-view', (refreshRouteName = route.name) => {
      if (theme.value.showProgressBar) VabProgress.start();
      const cacheActivePath = routerKey.value;
      routerKey.value = null;
      updateKeepAliveNameList(refreshRouteName);
      nextTick(() => {
        routerKey.value = cacheActivePath;
        updateKeepAliveNameList();
      });
      setTimeout(() => {
        if (theme.value.showProgressBar) VabProgress.done();
      }, 200);
    });
    onUnmounted(() => {
      $unsub('get-code');
      $unsub('reload-router-view');
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          mode: "out-in",
          name: _unref(theme).showPageTransition ? 'fade-transform' : 'no-transform'
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
            include: _unref(keepAliveNameList),
            max: _unref(keepAliveMaxNum)
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: _unref(routerKey),
            ref_key: "componentRef",
            ref: componentRef
          }))], 1032, ["include", "max"]))]),
          _: 2
        }, 1032, ["name"])]),
        _: 1
      });
    };
  }
});